import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../../components/loader/loader";
// import Snackbar from "../../../../../../components/snackbar/snackbar";
import Snackbar from "../../../../../components/snackbar/snackbar";
import {
  create_accademic_institution,
  update_academy_registration,
  update_vendor_registration,
  user_institutions_detail,
  user_vendor_detail,
} from "../../../user.api";
import {
  builtup,
  euip,
  jointVenture,
  landon,
  ownland,
} from "./components/areadata";

import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
export default function VendorEdit(props) {
  const [activeStep, setActiveStep] = useState(0);

  const [basicData, setBasicData] = useState({});

  const [addCount, setCount] = useState(1);
  const myRef = useRef(null);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [areamange, setareaManage] = useState(builtup);
  const [vendorId, setVendorId] = useState(null);
  // const getDomainTypes = () => {
  //   user_company_domain_list().then((res) => {
  //     setDomain(res.data);
  //     setCount(addCount + 1);
  //   });
  // };
  const getFileNmae = (url) => {
    let name = null;

    name = url.substring(url.lastIndexOf("/") + 1);
    return name;
  };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      setActiveStep(1);
      setBasicData({ ...data });
    } else if (id === 1) {
      setActiveStep(0);
    } else if (id === 2) {
      handleSubmit();
    }
  };
  const fetchError = (error) => {
    console.log(error.response.data);
    let errmsg = "";
    let errArry = [];

    if (error?.response?.data?.message) {
      errmsg = error.response.data;
    }
    if (error.response.data.error) {
      Object.keys(error.response.data.error).forEach((key) => {
        let err = String(error.response.data.error[key]);
        errArry.push(err);
      });
      errmsg = String(errArry);
    }

    return errmsg;
  };
  let userData = jwtDecode(props.state.payload);
  useEffect(() => {
    user_vendor_detail(userData?.user?.id).then((res) => {
      // let mobile_number= res?.phone_no,
      let Data = res?.data;
      setBasicData({
        ...userData.user,
        ...Data,
        phone_number: Data.phone,
        logo_name: Data?.logo_file_name,
        brochure_name: Data?.brochure_file_name,
        // file_registration_proof: Data?.file_registration_proof,
        // course_details: Data.courses,
        // file_name_proof: Data?.file_registration_proof
        //   ? getFileNmae(Data?.file_registration_proof)
        //   : null,
        // file_submitted_record: Data?.file_submitted_record,
        // file_name_request: Data?.file_submitted_record
        //   ? getFileNmae(Data?.file_submitted_record)
        //   : null,
        // registration_date: Data.registration_date
        //   ? moment(Data.registration_date, "YYYY-MM-DD").format("DD-MM-YYYY")
        //   : null,
      });
      setVendorId(Data.id);
      setCount(addCount + 1);
    });
  }, []);
  const handleSubmit = () => {
    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();

    form.append("name", basicData?.name ?? null);
    form.append("email", basicData?.email);
    if (basicData?.alternate_email && basicData?.alternate_email !== "null") {
      form.append("alternate_email", basicData?.alternate_email);
    }

    form.append("phone", basicData?.phone_number ?? null);
    if (basicData?.alternate_phone && basicData?.alternate_phone !== "null") {
      form.append("alternate_phone", basicData?.alternate_phone ?? null);
    }

    form.append("company_name", basicData?.company_name ?? null);
    form.append("address", basicData?.address ?? null);
    form.append("area_of_operation", basicData?.area_of_operation ?? "");
    form.append("company_description", basicData?.company_description ?? "");
    if (basicData?.alt_country_code && basicData?.alt_country_code !== "null") {
      form.append("alt_country_code", basicData?.alt_country_code ?? null);
    }

    // form.append("logo",basicData?.logo ??"")
    // form.append("brochure",basicData?.brochure ??"")
    if (basicData?.logo && typeof basicData?.logo !== "string") {
      form.append("logo", basicData.logo ?? "");
      form.append("logo_name", basicData.logo_name ?? "");
    }

    // Only append brochure if it's a valid file
    if (basicData?.brochure && basicData.brochure[0] instanceof File) {
      form.append("brochure", basicData.brochure[0]);
    }
    form.append("admin_reason", null);
    form.append("sadmin_reason", null);
    console.log(basicData);
    setIsActive(true);
    update_vendor_registration(vendorId, form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(
          typeof fetchError(error) === "string"
            ? fetchError(error)
            : "Something went wrong"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const headlperText = {
    header: "",
  };

  // useEffect(() => {
  //   if (domainData.length === 0) {
  //     getDomainTypes();
  //   }
  //   // handleChangedata("3");
  // }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/dashboard");
      // props.logout();
    }
  };

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">Update - Vendors</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="itemc">
            <div className="fomy form-inner-section">
              {activeStep === 0 && (
                <BasicDetails
                  {...props}
                  action={action}
                  formData={basicData}
                  update={true}
                />
              )}

              {activeStep === 1 && (
                <View
                  {...props}
                  basicData={basicData}
                  action={action}
                  update={true}
                />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
